module.exports = __webpack_public_path__ + "static/img/home0.077ccdf4.png";